import React, { useState, useCallback } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Loader2 } from 'lucide-react';
import { useMobileDetection } from '../hooks/useMobileDetection';
import { MobileRestrictionMessage } from '@/components/ui/MobileRestrictionMessage';

function Popup({ text, wholesaler_name, closePopup }) {
    const [loading, setLoading] = useState(true);
    const isMobile = useMobileDetection();

    const hideSpinner = useCallback(() => {
        setLoading(false);
    }, []);

    const handleOpenChange = useCallback((open) => {
        if (!open) {
            closePopup();
        }
    }, [closePopup]);

    // Build iframe URL
    let iframeUrl = '';
    if (wholesaler_name === 'Admin') {
        iframeUrl = 'home/iadmin';
    } else {
        iframeUrl = `home/uindex?wholeseller=${wholesaler_name}`;
    }

    return (
        <Dialog open={true} onOpenChange={handleOpenChange}>
            <DialogContent className="sm:max-w-4xl max-h-[90vh]">
                <DialogHeader>
                    <DialogTitle>{text}</DialogTitle>
                </DialogHeader>
                
                <div className="flex flex-col gap-4 relative">
                    {isMobile ? (
                        <MobileRestrictionMessage />
                    ) : loading ? (
                        <div className="flex items-center justify-center p-8 min-h-[120px] absolute inset-0 bg-background/80 z-10">
                            <Loader2 className="h-8 w-8 animate-spin text-primary" />
                        </div>
                    ) : (
                    <div className="relative w-full h-[70vh]">
                        <iframe
                            src={iframeUrl}
                            onLoad={hideSpinner}
                            className="w-full h-full border-0 rounded-md"
                            title={text}
                        />
                    </div>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default Popup;
